import React, { ChangeEvent } from 'react';

import { useLocale } from '@adsk/alloy-react-locale';
import TextField from '@adsk/nirvana-text-field';

import { SequenceNumberWrapper, FieldWrapper, LabelWrapper, FooterWrapper } from './styles';

type SequenceNumberType = {
  value?: { start?: string; increment?: string };
  errors?: { start?: React.ReactNode; increment?: React.ReactNode };
  maxLength?: number;
  footer?: React.ReactNode;
  /**
   * Callback function to handle the change of the input
   * with the shape of ({ start: string, increment: string }) => void
   */
  onChange: (value: { start?: string; increment?: string }) => void;
};
const SequenceNumber = React.forwardRef<HTMLDivElement, SequenceNumberType>(
  ({ value = {}, errors = {}, maxLength, footer, onChange, ...rest }, ref) => {
    const { T } = useLocale(({ locale }) => require(`../locale/${locale}.json`));
    return (
      <SequenceNumberWrapper ref={ref} {...rest}>
        <FieldWrapper>
          <LabelWrapper>{T.translate('start')}</LabelWrapper>
          <TextField
            data-testid="sequence-number-start-input"
            value={value.start}
            errorMessage={errors.start}
            placeholder={maxLength ? '#'.repeat(maxLength) : null}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              onChange({ start: e.target.value });
            }}
          />
        </FieldWrapper>
        <FieldWrapper>
          <LabelWrapper>{T.translate('increment')}</LabelWrapper>
          <TextField
            data-testid="sequence-number-increment-input"
            value={value.increment}
            errorMessage={errors.increment}
            placeholder={T.translate('incrementPlaceholder')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              onChange({ increment: e.target.value });
            }}
          />
          {footer && <FooterWrapper hasError={!!errors.increment}>{footer}</FooterWrapper>}
        </FieldWrapper>
      </SequenceNumberWrapper>
    );
  }
);
SequenceNumber.displayName = 'SequenceNumber';

export default SequenceNumber;
